import Reflux from 'reflux'

export default Reflux.createActions([
	'login',
	'logout'
])



// WEBPACK FOOTER //
// ./src/actions/auth.js